<script>
export default {
  name: 'PopupMan',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    isMore: false,
    // shop_link_url: 'https://www.google.com.tw',
    // shop_link_url: '',
    // DM: false,
    // links: [
    //   { link_type: 'Web', link_icon_name: '前往', link_url: 'https://www.google.com.tw' },
    //   { link_type: 'Facebook', link_icon_name: '前往Fb', link_url: 'https://www.google.com.tw' },
    //   { link_type: 'LINE', link_icon_name: '前往LINE連結', link_url: 'https://www.google.com.tw' },
    // ],
  }),
  methods: {
    closePopup() {
      this.$emit('update:modelValue', false)
    },
    openLink() {
      this.isMore = true
    },
    closeMoreLink() {
      this.isMore = false
    },
    isExternalLink(url) {
      if (!url) return false
      return url.startsWith('http://') || url.startsWith('https://')
    },
    handleLinkClick(url) {
      if (this.isExternalLink(url)) {
        window.open(url, '_blank', 'noopener,noreferrer')
      } else {
        this.$router.push(url)
      }
    },
    handleClickOutside(event) {
      const moreLinkEl = this.$refs.moreLink
      // 檢查所有可能的觸發按鈕
      const triggerBtns = [
        this.$refs.triggerBtnMore,
        // 可以添加其他觸發按鈕的 ref
      ].filter(Boolean) // 過濾掉 undefined 的 ref

      const isClickInsideAnyTrigger = triggerBtns.some(btn => btn && btn.contains(event.target))

      if (moreLinkEl && !moreLinkEl.contains(event.target) && !isClickInsideAnyTrigger) {
        this.closeMoreLink()
      }
    },
  },
  computed: {
    filterData() {
      if (
        !this.$props.data.DM &&
        !this.$props.data.shop_link_url &&
        this.$props.data.links.length > 2
      ) {
        return this.$props.data.links.slice(1)
      }
      return this.$props.data.links
    },
  },
  mounted() {
    // 添加全局點擊監聽器
    console.log('this.$props.datathis.$props.datathis.$props.datathis.$props.datathis.$props.datathis.$props.data',this.$props.data);
    
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    // 移除監聽器，避免內存洩漏
    document.removeEventListener('click', this.handleClickOutside)
  },
  watch: {},
}
</script>

<template>
  <transition name="fade" appear>
    <div class="wrapper2">
      <div class="wrapper" @click="closePopup"></div>
      <div class="popup">
        <div class="close" @click="closePopup">
          <img src="@/assets/images/homeclose.png" alt="" />
        </div>
        <div class="content">
          <div v-if="isMore" ref="moreLink" class="moreLink">
            <div
              class="link"
              style="display: flex; gap: 8px; align-items: center"
              v-for="(link, index) in filterData"
              :key="index"
              @click="handleLinkClick(link.link_url)"
            >
              <v-btn style="width: 24px; height: 24px; margin: 0" icon>
                <img
                  alt="logo"
                  v-show="link.link_type === 'Facebook'"
                  :src="require('@/assets/images/FACEBOOK_Logo.svg')"
                />
                <img
                  alt="logo"
                  v-show="link.link_type === 'LINE'"
                  :src="require('@/assets/images/LINE_LOGO.svg')"
                />
                <img
                  alt="logo"
                  v-show="link.link_type !== 'LINE' && link.link_type !== 'Facebook'"
                  :src="require('@/assets/images/other.svg')"
                />
              </v-btn>
              <p style="font-size: 14px; line-height: 16.8px; vertical-align: center">
                {{ link?.link_icon_name }}
              </p>
            </div>
          </div>
          <div
            :class="{
              icon: data.type === '促銷' || data.type === '熱門',
              cheap: data.type === '促銷',
              hot: data.type === '熱門',
            }"
            class="sell"
            v-show="data.type"
          >
            <img
              v-if="data.type === '促銷'"
              src="@/assets/images/hotsell.svg"
              style="width: 18px; height: 18px"
              alt=""
            />
            <img
              v-else-if="data.type === '熱門'"
              src="@/assets/images/cheapsell.svg"
              style="width: 18px; height: 18px"
              alt=""
            />
            {{ data.type }}
          </div>
          <img class="dog_card" :src="data.imgSrc" />
          <img
            style="position: relative; width: 100%; margin-top: 10px"
            src="@/assets/images/intersect.png"
            alt=""
          />
          <div class="title" style="padding: 0px 24px">{{ data.title }}</div>
          <div class="price" style="padding: 0px 24px">
            <p class="normal" v-show="data.promotion">${{ data.price }}</p>
            <p class="cut">${{ data.promotion || data.price }}</p>
          </div>
          <div
            v-if="data.DM || data.shop_link_url || data.links.length > 0"
            class="bcc"
            style="padding: 0px 24px"
          >
            <!-- 一個按鈕 -->
            <div
              v-if="
                (data.shop_link_url && data.links.length === 0 && !data.DM) ||
                (!data.shop_link_url && data.links.length === 0 && data.DM) ||
                (!data.shop_link_url && data.links.length === 1 && !data.DM)
              "
              style="width: 100%"
            >
              <div
                v-if="data.shop_link_url && data.links.length === 0 && !data.DM"
                class="btn-container"
                @click="handleLinkClick(data.shop_link_url)"
              >
                <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img alt="logo" :src="require('@/assets/images/buynow.svg')" />
                </v-btn>
                <p class="body-semibold">前往購買</p>
              </div>
              <div
                v-if="!data.shop_link_url && data.links.length === 0 && data.DM"
                class="btn-menu"
                @click="handleLinkClick('/dm')"
              >
                <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img alt="logo" :src="require('@/assets/images/menu.svg')" />
                </v-btn>
                <p class="body-semibold">目錄</p>
              </div>
              <div
                v-if="!data.shop_link_url && data.links.length === 1 && !data.DM"
                class="btn-menu"
                @click="handleLinkClick(data.links[0]?.link_url)"
              >
                <v-btn v-show="data.links[0]?.link_type === 'Facebook' || data.links[0]?.link_type === 'LINE'" class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img
                    alt="logo"
                    v-show="data.links[0]?.link_type === 'Facebook'"
                    :src="require('@/assets/images/FACEBOOK_Logo.svg')"
                  />
                  <img
                    alt="logo"
                    v-show="data.links[0]?.link_type === 'LINE'"
                    :src="require('@/assets/images/LINE_LOGO.svg')"
                  />
                </v-btn>
                <p class="body-semibold">{{ data.links[0]?.link_icon_name }}</p>
              </div>
            </div>

            <!-- 二個按鈕 -->
            <div
              v-else-if="
                (data.shop_link_url && data.DM && data.links.length === 0) ||
                (data.shop_link_url && data.links.length === 1 && !data.DM) ||
                (data.DM && data.links.length === 1 && !data.shop_link_url) ||
                (data.links.length === 2 && !data.DM && !data.shop_link_url)
              "
              style="display: flex; gap: 16px; width: 100%"
            >
              <div
                v-if="data.shop_link_url"
                class="btn-container"
                style="flex: 1"
                @click="handleLinkClick(data.shop_link_url)"
              >
                <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img alt="logo" :src="require('@/assets/images/buynow.svg')" />
                </v-btn>
                <p class="body-semibold">前往購買</p>
              </div>
              <div
                v-if="data.DM"
                class="btn-menu"
                style="width: 93px"
                @click="handleLinkClick('/dm')"
              >
                <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img alt="logo" :src="require('@/assets/images/menu.svg')" />
                </v-btn>
                <p class="body-semibold">目錄</p>
              </div>
              <div
                v-if="data.links.length === 1"
                class="btn-menu"
                style="width: fit-content; padding: 0 16px"
                :style="{ flex: data.DM ? '1' : 'none' }"
                @click="handleLinkClick(data.links[0]?.link_url)"
              >
                <v-btn v-show="data.links[0]?.link_type === 'Facebook' || data.links[0]?.link_type === 'LINE'" class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img
                    alt="logo"
                    v-show="data.links[0]?.link_type === 'Facebook'"
                    :src="require('@/assets/images/FACEBOOK_Logo.svg')"
                  />
                  <img
                    alt="logo"
                    v-show="data.links[0]?.link_type === 'LINE'"
                    :src="require('@/assets/images/LINE_LOGO.svg')"
                  />
                </v-btn>
                <p class="body-semibold">{{ data.links[0]?.link_icon_name }}</p>
              </div>
              <div
                v-if="data.links.length === 2"
                class="btn-menu"
                style="width: fit-content; padding: 0 16px; flex: 1"
                @click="handleLinkClick(data.links[0]?.link_url)"
              >
                <v-btn v-show="data.links[0]?.link_type !== 'Web'" class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img
                    alt="logo"
                    v-show="data.links[0]?.link_type === 'Facebook'"
                    :src="require('@/assets/images/FACEBOOK_Logo.svg')"
                  />
                  <img
                    alt="logo"
                    v-show="data.links[0]?.link_type === 'LINE'"
                    :src="require('@/assets/images/LINE_LOGO.svg')"
                  />
                </v-btn>
                <p class="body-semibold">{{ data.links[0]?.link_icon_name }}</p>
              </div>
              <div
                v-if="data.links.length === 2"
                class="btn-menu"
                style="width: fit-content; padding: 0 16px; flex: 1"
                @click="handleLinkClick(data.links[1]?.link_url)"
              >
                <v-btn v-show="data.links[1]?.link_type === 'Facebook' || data.links[1]?.link_type === 'LINE'" class="" style="width: 24px; height: 24px; margin: 0" icon>
                  <img
                    alt="logo"
                    v-show="data.links[1]?.link_type === 'Facebook'"
                    :src="require('@/assets/images/FACEBOOK_Logo.svg')"
                  />
                  <img
                    alt="logo"
                    v-show="data.links[1]?.link_type === 'LINE'"
                    :src="require('@/assets/images/LINE_LOGO.svg')"
                  />
                </v-btn>
                <p class="body-semibold">{{ data.links[1]?.link_icon_name }}</p>
              </div>
            </div>

            <!-- 三個按鈕 -->
            <div v-else style="width: 100%">
              <div
                v-if="data.shop_link_url && data.DM && data.links.length >= 1"
                style="display: flex; gap: 8px; width: 100%"
              >
                <div
                  class="btn-container"
                  style="flex: 1"
                  @click="handleLinkClick(data.shop_link_url)"
                >
                  <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img alt="logo" :src="require('@/assets/images/buynow.svg')" />
                  </v-btn>
                  <p class="body-semibold">前往購買</p>
                </div>
                <div class="btn-menu" style="width: 48px" @click="handleLinkClick('/dm')">
                  <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img alt="logo" :src="require('@/assets/images/menu.svg')" />
                  </v-btn>
                </div>
                <div ref="triggerBtnMore" class="btn-more" @click="openLink">
                  <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img alt="logo" :src="require('@/assets/images/what.svg')" />
                  </v-btn>
                </div>
              </div>
              <div
                v-else-if="
                  ((data.DM && !data.shop_link_url) || (data.shop_link_url && !data.DM)) &&
                  data.links.length > 1
                "
                style="display: flex; gap: 8px; width: 100%"
              >
                <div
                  v-if="data.shop_link_url"
                  class="btn-container"
                  style="width: calc(100% - 48px)"
                  @click="handleLinkClick(data.shop_link_url)"
                >
                  <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img alt="logo" :src="require('@/assets/images/buynow.svg')" />
                  </v-btn>
                  <p class="body-semibold">前往購買</p>
                </div>
                <div
                  v-if="data.DM"
                  class="btn-menu"
                  style="width: calc(100% - 48px)"
                  @click="handleLinkClick('/dm')"
                >
                  <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img alt="logo" :src="require('@/assets/images/menu.svg')" />
                  </v-btn>
                  <p v-if="!data.shop_link_url" class="body-semibold">目錄</p>
                </div>
                <div ref="triggerBtnMore" class="btn-more" @click="openLink">
                  <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img alt="logo" :src="require('@/assets/images/what.svg')" />
                  </v-btn>
                </div>
              </div>
              <div v-else style="display: flex; gap: 8px; width: 100%">
                <div
                  class="btn-container-more"
                  style="width: calc(100% - 48px);"
                  @click="handleLinkClick(data.links[0]?.link_url)"
                >
                  <v-btn v-show="data.links[0]?.link_type === 'Facebook' || data.links[0]?.link_type === 'LINE'" class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img
                      alt="logo"
                      v-show="data.links[0]?.link_type === 'Facebook'"
                      :src="require('@/assets/images/FACEBOOK_Logo.svg')"
                    />
                    <img
                      alt="logo"
                      v-show="data.links[0]?.link_type === 'LINE'"
                      :src="require('@/assets/images/LINE_LOGO.svg')"
                    />
                  </v-btn>
                  <p class="body-semibold">{{ data.links[0]?.link_icon_name }}</p>
                </div>
                <div ref="triggerBtnMore" class="btn-more" @click="openLink">
                  <v-btn class="" style="width: 24px; height: 24px; margin: 0" icon>
                    <img alt="logo" :src="require('@/assets/images/what.svg')" />
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.moreLink {
  position: absolute;
  bottom: 52px;
  right: -20px;
  padding: 12px;
  background-color: #fff;
  min-width: 166px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: -1px -1px 20px 0px #00000014, 1px 1px 20px 0px #00000014;
  border-radius: 14px;
  & .link {
    padding: 16px 8px;
    width: 100%;
  }
}
.bcc {
  margin-top: 24px;
}
.btn-more {
  color: #ff9f4b;
  cursor: pointer;
  background-color: #fff;
  border: solid 2px #ff9f4b;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 18px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.btn-menu {
  color: #ff9f4b;
  cursor: pointer;
  background-color: #fff;
  border: solid 2px #ff9f4b;
  flex-shrink: 0;
  width: 100%;
  height: 48px;
  border-radius: 18px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.btn-container {
  color: #fff;
  cursor: pointer;
  background-color: #ff9f4b;
  width: 100%;
  height: 48px;
  border-radius: 18px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  &:active {
    background-color: #d16200;
  }
}
.btn-container-more {
  color: #ff9f4b;
  cursor: pointer;
  background-color: #fff;
  border: solid 2px #ff9f4b;
  width: 100%;
  height: 48px;
  border-radius: 18px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  &:active {
    background-color: #d16200;
  }
}
.btn {
  margin: 24px 0px 0px !important;
}
.wrapper2 {
  touch-action: manipulation;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // background-color: #0D0C0CB2;
  z-index: 9998;
}
.wrapper2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #0d0c0cb2;
  z-index: 9998;
}
.close {
  position: absolute;
  width: 100%;
  height: 100%;
  & img {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 20px);
    width: 30px;
    height: 30px;
  }
}
.dog_card {
  width: calc(100% - 48px);
  margin: 0 auto;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 8px;
}
.popup {
  position: absolute;
  // overflow: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  width: 312px;
  min-height: 336px;
  display: flex;
  border-radius: 18px;
  box-shadow: 1px 1px 4px -2px #4b25181f;
  z-index: 9998;
}
.content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 24px 0px;
  box-sizing: border-box;
  text-align: start;
  // gap: 12px;
  & .sell {
    position: absolute;
    top: 24px;
    left: 16px;
    display: flex;
    align-items: center;
    background-color: #ff7649;
    color: white;
    border-radius: 4px;
    width: fit-content;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    padding: 5px 8px 5px 8px;
    &.icon {
      padding: 6px 8px 6px 6px !important;
    }
    &.cheap {
      background-color: #ff453a !important;
    }
    &.hot {
      background-color: #ffc300 !important;
    }
  }
}
.title {
  font-family: Noto Sans TC;
  color: #0d0c0c;
  font-size: 18px;
  font-weight: 400;
  line-height: 22.8px;
  letter-spacing: 4%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin: 16px 0px 12px;
}
.price {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 6px;
  & .normal {
    font-size: 16px;
    line-height: 19.2px;
    text-decoration: line-through;
    color: #ccc;
  }
  & .cut {
    font-weight: bold;
    font-size: 24px;
    line-height: 28.8px;
    color: #ff7649;
  }
}
</style>
